// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accordion-version-two/accordion-version-two.component.scss
// module id = 79
// module chunks = 0